<template>
    <div>
        <ValidationObserver ref="filterForm">
        <b-row>
            <b-col cols="12" md="4">
                <b-form-group :label="$t('report_type')">
                    <multi-selectbox
                        :allow-empty="false" :multiple="false"
                        :options="responseTypeOptions" v-model="responseType"
                    ></multi-selectbox>
                </b-form-group>
            </b-col>
            <b-col cols="12">
                <b-button variant="primary" @click="getReport">
                    {{ $t('get_report').toUpper() }}
                </b-button>
            </b-col>
        </b-row>
        </ValidationObserver>
    </div>
</template>

<script>
import MultiSelectbox from "@/components/interactive-fields/MultiSelectbox"
import LecturerReportService from "@/services/LecturerReportService"
import qs from "qs"
import {ValidationObserver, ValidationProvider} from "vee-validate";

export default {
    components: {
        MultiSelectbox,
        ValidationProvider,
        ValidationObserver,
    },
    data() {
        return {
            filter: {},
            responseType: 'page',
            responseTypeOptions: [
                {value: 'page', text: this.$t('page')},
                {value: 'excel', text: this.$t('excel')},
                {value: 'pdf', text: 'PDF'}
            ]
        }
    },
    methods: {
        async getReport() {
            const isValid = await this.$refs.filterForm.validate()
            if (isValid) {
                const config = {
                    params: {
                        filter: {
                            ...this.filter
                        },
                        response_type: this.responseType,

                    },
                    paramsSerializer: (params) => qs.stringify(params, {encode: false})
                }
                if (this.responseType != 'page') {
                    config.responseType = 'arraybuffer'
                }

                LecturerReportService.studentVirtualInternshipReport(config)
                    .then((response) => {
                        if (this.responseType == 'page') {
                            this._openFile(response);
                        } else {
                            this._downloadFile(response, this.$t('Virtual-Internships-Report'));
                        }
                    })
                    .catch((error) => {
                        this.showErrors(error)
                    })
            }
        }
    }
}
</script>
